export class FileResponse {
  public fileDownloadUri: string;
  public fileName: string;
  public fileSize: number;

  constructor(fileDownloadUri: string, fileName: string, fileSize: number) {
    this.fileDownloadUri = fileDownloadUri;
    this.fileName = fileName;
    this.fileSize = fileSize;
  }
}
